import { Link, useLoaderData } from "react-router-dom";
import * as API from "../services/who5";

export async function loader({ params }) {
  const token = sessionStorage.getItem("token");

  // Si no hay token, simplemente NO llamamos a la API y retornamos null
  if (!token) {
    return null;
  }
  return API.getWho5ByID(params.who5Id);
}

export function Who5Item(props) {
  const who5 = useLoaderData();
  const errorMessage = who5.message;

  const who5Resp = who5.meta?.who5Resp;
  const metaFecha = who5.meta?.metaFecha;
  const who5Alegre = who5.meta?.who5Alegre;
  const who5Tranquilo = who5.meta?.who5Tranquilo;
  const who5Activo = who5.meta?.who5Activo;
  const who5Despejado = who5.meta?.who5Despejado;
  const who5Interesan = who5.meta?.who5Interesan;

  const who5Date = new Date(who5.date);
  const diffDate = Math.abs(new Date() - who5Date) / 36e5;

  /// Sum of all WHO-5 test responses
  const totalSumWho5 =
  4 *
  ((parseInt(who5Alegre) || 0) +
    (parseInt(who5Tranquilo) || 0) +
    (parseInt(who5Activo) || 0) +
    (parseInt(who5Despejado) || 0) +
    (parseInt(who5Interesan) || 0));

  const createResultProperties = (result, low, high) => {
    // Convertir los strings que vienen del meta a numbers
    result = parseFloat(result);
    low = parseFloat(low);
    high = parseFloat(high);
    const color =
      result >= low && result <= high
        ? "anali-result-good"
        : "anali-result-bad";
    const markIn = Math.min(
      Math.max(((result - low) / (high - low)) * 100, 0),
      100
    ).toFixed(0);
    const markOut =
      result < low
        ? "anali-result-low"
        : result > high
        ? "anali-result-high"
        : "";
    return { color, markIn, markOut };
  };

  // Graphics
  const limits = {
    compT: { low: 0, high: 100 },
  };

  const {
    color: sumCompTColor,
    markIn: sumCompTMarkIn,
    markOut: sumCompTMarkOut,
  } = createResultProperties(totalSumWho5, limits.compT.low, limits.compT.high);

  return (
    <>
      <div id='content'>
        {who5.length === 0 ? (
          <div>Cargando...</div>
        ) : errorMessage ? (
          <p>{errorMessage}</p>
        ) : (
          <form id='formUpdatelement' className='newRadioButtons'>
            <fieldset id='disabledContainer' disabled='disabled'>
              <div className='grid--2col'>
                <div className='field'>
                  <label htmlFor='who5Resp'>Responsable</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='who5Resp'
                      required
                      type='text'
                      value={who5Resp}
                      readOnly
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='metaFecha'>Fecha visita</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='metaFecha'
                      required
                      type='date'
                      value={metaFecha}
                      readOnly
                    />
                  </div>
                </div>
              </div>
              <h3>Cuestionario WHO-5</h3>
              <div className='form-radio-container'>
                <div className='grid--2-col'>
                  <div className='radio-capt radio--6-col'>
                    <p>Todo el tiempo</p>
                    <p>La mayor parte del tiempo</p>
                    <p>Más de la mitad del tiempo</p>
                    <p>Menos de la mitad del tiempo</p>
                    <p>Algo del tiempo</p>
                    <p>En ningún momento</p>
                  </div>
                </div>
                <div className='field'>
                  <div className='control grid--2col'>
                    <label className='radio-title' htmlFor='who5Alegre'>
                      1. me he sentido alegre y con buen ánimo
                    </label>
                    <div className='radio--6-col'>
                      <label className='radio' htmlFor='who5Alegre-5'>
                        <input
                          id='who5Alegre-5'
                          name='who5Alegre'
                          type='radio'
                          value='5'
                          checked={who5Alegre === "5"}
                          readOnly
                        />
                        5
                      </label>
                      <label className='radio' htmlFor='who5Alegre-4'>
                        <input
                          id='who5Alegre-4'
                          name='who5Alegre'
                          type='radio'
                          value='4'
                          checked={who5Alegre === "4"}
                          readOnly
                        />
                        4
                      </label>
                      <label className='radio' htmlFor='who5Alegre-3'>
                        <input
                          id='who5Alegre-3'
                          name='who5Alegre'
                          type='radio'
                          value='3'
                          checked={who5Alegre === "3"}
                          readOnly
                        />
                        3
                      </label>
                      <label className='radio' htmlFor='who5Alegre-2'>
                        <input
                          id='who5Alegre-2'
                          name='who5Alegre'
                          type='radio'
                          value='2'
                          checked={who5Alegre === "2"}
                          readOnly
                        />
                        2
                      </label>
                      <label className='radio' htmlFor='who5Alegre-1'>
                        <input
                          id='who5Alegre-1'
                          name='who5Alegre'
                          type='radio'
                          value='1'
                          checked={who5Alegre === "1"}
                          readOnly
                        />
                        1
                      </label>
                      <label className='radio' htmlFor='who5Alegre-0'>
                        <input
                          id='who5Alegre-0'
                          name='who5Alegre'
                          type='radio'
                          value='0'
                          checked={who5Alegre === "0"}
                          readOnly
                        />
                        0
                      </label>
                    </div>
                  </div>
                </div>
                <div className='field'>
                  <div className='control grid--2col'>
                    <label className='radio-title' htmlFor='who5Tranquilo'>
                      2. me he sentido tranquilo y relajado
                    </label>
                    <div className='radio--6-col'>
                      <label className='radio' htmlFor='who5Tranquilo-5'>
                        <input
                          id='who5Tranquilo-5'
                          name='who5Tranquilo'
                          type='radio'
                          value='5'
                          checked={who5Tranquilo === "5"}
                          readOnly
                        />
                        5
                      </label>
                      <label className='radio' htmlFor='who5Tranquilo-4'>
                        <input
                          id='who5Tranquilo-4'
                          name='who5Tranquilo'
                          type='radio'
                          value='4'
                          checked={who5Tranquilo === "4"}
                          readOnly
                        />
                        4
                      </label>
                      <label className='radio' htmlFor='who5Tranquilo-3'>
                        <input
                          id='who5Tranquilo-3'
                          name='who5Tranquilo'
                          type='radio'
                          value='3'
                          checked={who5Tranquilo === "3"}
                          readOnly
                        />
                        3
                      </label>
                      <label className='radio' htmlFor='who5Tranquilo-2'>
                        <input
                          id='who5Tranquilo-2'
                          name='who5Tranquilo'
                          type='radio'
                          value='2'
                          checked={who5Tranquilo === "2"}
                          readOnly
                        />
                        2
                      </label>
                      <label className='radio' htmlFor='who5Tranquilo-1'>
                        <input
                          id='who5Tranquilo-1'
                          name='who5Tranquilo'
                          type='radio'
                          value='1'
                          checked={who5Tranquilo === "1"}
                          readOnly
                        />
                        1
                      </label>
                      <label className='radio' htmlFor='who5Tranquilo-0'>
                        <input
                          id='who5Tranquilo-0'
                          name='who5Tranquilo'
                          type='radio'
                          value='0'
                          checked={who5Tranquilo === "0"}
                          readOnly
                        />
                        0
                      </label>
                    </div>
                  </div>
                </div>
                <div className='field'>
                  <div className='control grid--2col'>
                    <label className='radio-title' htmlFor='who5Activo'>
                      3. me he sentido activo y con energía
                    </label>
                    <div className='radio--6-col'>
                      <label className='radio' htmlFor='who5Activo-5'>
                        <input
                          id='who5Activo-5'
                          name='who5Activo'
                          type='radio'
                          value='5'
                          checked={who5Activo === "5"}
                          readOnly
                        />
                        5
                      </label>
                      <label className='radio' htmlFor='who5Activo-4'>
                        <input
                          id='who5Activo-4'
                          name='who5Activo'
                          type='radio'
                          value='4'
                          checked={who5Activo === "4"}
                          readOnly
                        />
                        4
                      </label>
                      <label className='radio' htmlFor='who5Activo-3'>
                        <input
                          id='who5Activo-3'
                          name='who5Activo'
                          type='radio'
                          value='3'
                          checked={who5Activo === "3"}
                          readOnly
                        />
                        3
                      </label>
                      <label className='radio' htmlFor='who5Activo-2'>
                        <input
                          id='who5Activo-2'
                          name='who5Activo'
                          type='radio'
                          value='2'
                          checked={who5Activo === "2"}
                          readOnly
                        />
                        2
                      </label>
                      <label className='radio' htmlFor='who5Activo-1'>
                        <input
                          id='who5Activo-1'
                          name='who5Activo'
                          type='radio'
                          value='1'
                          checked={who5Activo === "1"}
                          readOnly
                        />
                        1
                      </label>
                      <label className='radio' htmlFor='who5Activo-0'>
                        <input
                          id='who5Activo-0'
                          name='who5Activo'
                          type='radio'
                          value='0'
                          checked={who5Activo === "0"}
                          readOnly
                        />
                        0
                      </label>
                    </div>
                  </div>
                </div>
                <div className='field'>
                  <div className='control grid--2col'>
                    <label className='radio-title' htmlFor='who5Despejado'>
                      4. me he despertado sintiéndome despejado y descansado
                    </label>
                    <div className='radio--6-col'>
                      <label className='radio' htmlFor='who5Despejado-5'>
                        <input
                          id='who5Despejado-5'
                          name='who5Despejado'
                          type='radio'
                          value='5'
                          checked={who5Despejado === "5"}
                          readOnly
                        />
                        5
                      </label>
                      <label className='radio' htmlFor='who5Despejado-4'>
                        <input
                          id='who5Despejado-4'
                          name='who5Despejado'
                          type='radio'
                          value='4'
                          checked={who5Despejado === "4"}
                          readOnly
                        />
                        4
                      </label>
                      <label className='radio' htmlFor='who5Despejado-3'>
                        <input
                          id='who5Despejado-3'
                          name='who5Despejado'
                          type='radio'
                          value='3'
                          checked={who5Despejado === "3"}
                          readOnly
                        />
                        3
                      </label>
                      <label className='radio' htmlFor='who5Despejado-2'>
                        <input
                          id='who5Despejado-2'
                          name='who5Despejado'
                          type='radio'
                          value='2'
                          checked={who5Despejado === "2"}
                          readOnly
                        />
                        2
                      </label>
                      <label className='radio' htmlFor='who5Despejado-1'>
                        <input
                          id='who5Despejado-1'
                          name='who5Despejado'
                          type='radio'
                          value='1'
                          checked={who5Despejado === "1"}
                          readOnly
                        />
                        1
                      </label>
                      <label className='radio' htmlFor='who5Despejado-0'>
                        <input
                          id='who5Despejado-0'
                          name='who5Despejado'
                          type='radio'
                          value='0'
                          checked={who5Despejado === "0"}
                          readOnly
                        />
                        0
                      </label>
                    </div>
                  </div>
                </div>
                <div className='field'>
                  <div className='control grid--2col'>
                    <label className='radio-title' htmlFor='who5Interesan'>
                      5. mi vida diaria se ha llenado de cosas que me interesan
                    </label>
                    <div className='radio--6-col'>
                      <label className='radio' htmlFor='who5Interesan-5'>
                        <input
                          id='who5Interesan-5'
                          name='who5Interesan'
                          type='radio'
                          value='5'
                          checked={who5Interesan === "5"}
                          readOnly
                        />
                        5
                      </label>
                      <label className='radio' htmlFor='who5Interesan-4'>
                        <input
                          id='who5Interesan-4'
                          name='who5Interesan'
                          type='radio'
                          value='4'
                          checked={who5Interesan === "4"}
                          readOnly
                        />
                        4
                      </label>
                      <label className='radio' htmlFor='who5Interesan-3'>
                        <input
                          id='who5Interesan-3'
                          name='who5Interesan'
                          type='radio'
                          value='3'
                          checked={who5Interesan === "3"}
                          readOnly
                        />
                        3
                      </label>
                      <label className='radio' htmlFor='who5Interesan-2'>
                        <input
                          id='who5Interesan-2'
                          name='who5Interesan'
                          type='radio'
                          value='2'
                          checked={who5Interesan === "2"}
                          readOnly
                        />
                        2
                      </label>
                      <label className='radio' htmlFor='who5Interesan-1'>
                        <input
                          id='who5Interesan-1'
                          name='who5Interesan'
                          type='radio'
                          value='1'
                          checked={who5Interesan === "1"}
                          readOnly
                        />
                        1
                      </label>
                      <label className='radio' htmlFor='who5Interesan-0'>
                        <input
                          id='who5Interesan-0'
                          name='who5Interesan'
                          type='radio'
                          value='0'
                          checked={who5Interesan === "0"}
                          readOnly
                        />
                        0
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div className='analitic-form form-results form-results-new form-results-audit'>
                <h3>Resultados de la autoevaluación WHO 5</h3>
                <div className="three-col-analitic">

                {/* Componente 0: Puntuación Global */}
                <div className="anali-el">
                  <p className="anali-title">Puntuación Global</p>
                  <div className="anali-result-container">
                    <p className={`anali-result ${sumCompTColor}`}>
                      {totalSumWho5}
                    </p>
                    <div className={`anali-bar-full ${sumCompTMarkOut}`}>
                      <div className="anali-bar anali-bar-low"></div>
                      <div className="anali-bar anali-bar-main">
                        <div
                          className="anali-bar-mark"
                          style={{
                            left: `${sumCompTMarkIn}%`,
                          }}
                        ></div>
                      </div>
                      <div className="anali-bar anali-bar-high"></div>
                    </div>
                    <div className="anali-limit-container">
                      <p className="anali-limit anali-limit-low">
                        {limits.compT.low}
                      </p>
                      <p className="anali-limit anali-limit-high">
                        {limits.compT.high}
                      </p>
                    </div>
                  </div>
                </div>
                </div>
              </div>
            </fieldset>
          </form>
        )}
      </div>

      {!errorMessage && (
        <div id='actions'>
          {(diffDate <= 72 || props.userRole.includes("administrador")) && (
            <Link className='button is-link' to={`edit`}>
              Editar
            </Link>
          )}
        </div>
      )}
    </>
  );
}
